/**
 * External dependencies
 */
import inherits from 'inherits';

export default class User {
    constructor(cscom) {
        if (!(this instanceof User)) {
            return new User(cscom);
        }
        this.cscom = cscom;
    }

    getUserById(id) {
        return this.cscom.req.get('/api/tower-users/' + id, null, null);
    }

    retrieveChargebeeCustomer() {
        return this.cscom.req.get('/customer-site-api/user/retrieveChargebeeCustomer', null, null);
    }
}
